module.exports = __webpack_public_path__ + "img/应急处理-bg.5ba94e0e.jpg";